import { useQuery } from '@tanstack/react-query';
import type { Banner } from '@skytech/shared';

import { api } from '../../lib/api';

/** Active homepage hero banners (SRS §4.2), already schedule-filtered + ordered by the API. */
export function useBanners() {
  return useQuery({
    queryKey: ['banners'],
    queryFn: async () => (await api.get<Banner[]>('/banners')).data,
    staleTime: 60_000,
  });
}
